var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('transition-group',{attrs:{"appear":"","name":"fade"}},_vm._l((_vm.hints),function(hint,index){return _c('div',{key:hint.text + index},[_c('Hint',{attrs:{"hint":hint,"show":hint.show}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }